import React, { useEffect } from "react";
import PageLayout from "../components/PageLayout";
import PageHero from "../components/PageHero";
import ReferenceCard from "../components/ReferenceCard";
import { useT } from "../context/LanguageContext";
import references from "../data/references";
import "../components/ReferencesSection.css";

const ReferencesPage = () => {
  const t = useT();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <PageLayout hero={<PageHero title={t("references.title")} subtitle={t("references.description")} />}>
      <section className="px-6 pb-24" aria-label={t("references.title")}>
        <ul className="references-grid mx-auto max-w-6xl">
          {references.map((reference) => (
            <li key={reference.name}>
              <ReferenceCard {...reference} />
            </li>
          ))}
        </ul>
      </section>
    </PageLayout>
  );
};

export default ReferencesPage;
